import { cn } from '@natu/utils/cn';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { type SBProps, type BlokItem, DynamicRender, sbEditable } from '../../../../utils';
import {
  type RecruitmentBarHeight,
  type RecruitmentBarWidth,
  getRecruitmentBarClasses,
} from './utils';

type RecruitmentProcessBarProps = {
  _uid?: string;
  height?: RecruitmentBarHeight;
  width?: RecruitmentBarWidth;
  text?: string;
};

interface SBRecruitmentProcessProps {
  bars?: RecruitmentProcessBarProps[];
  body?: BlokItem[];
}
export const SBRecruitmentProcess = ({ blok }: SBProps<SBRecruitmentProcessProps>) => {
  const { bars, body } = blok;
  const withBars = isArrayWithLength(bars);

  return (
    <div
      className={cn('grid gap-8 md:grid-cols-1', withBars ? 'grid-cols-[32px_1fr]' : 'grid-cols-1')}
      {...sbEditable(blok)}
    >
      {withBars && (
        <div className="flex flex-col gap-4 md:flex-row">
          {bars.map(bar => (
            <div
              key={bar._uid}
              className={cn(
                'text-md text-naturaily-vulcan flex items-center justify-center rounded-lg bg-white p-1 font-bold',
                'md:h-auto md:text-lg',
                getRecruitmentBarClasses(bar.height, bar.width),
              )}
            >
              <span className="block rotate-90 whitespace-nowrap md:rotate-0">{bar.text}</span>
            </div>
          ))}
        </div>
      )}
      <DynamicRender data={body} />
    </div>
  );
};
